import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"

import {
  Box,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
} from "@mui/material"
export default function ModesTab({ localProject, setLocalProject }) {
  return (
    <Box>
      <FormControl component="fieldset" margin="normal">
        <RadioGroup
          value={localProject.budgetMode || "standard"}
          onChange={e =>
            setLocalProject(lp => ({
              ...lp,
              budgetMode: e.target.value,
            }))
          }
        >
          <FormControlLabel
            value="standard"
            control={<Radio />}
            label={i18n.t("editProject.standardMode")}
          />
          <FormControlLabel
            value="tender"
            control={<Radio />}
            label={i18n.t("editProject.tenderMode")}
          />
        </RadioGroup>
      </FormControl>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {i18n.t("editProject.modesMoreInfo")}{" "}
        <a
          href="https://help.planhopper.com/en/help/articles/0645407-modos-de-presupuesto"
          target="_blank"
          rel="noreferrer"
          style={{ color: "#1976d2" }}
        >
          {i18n.t("editProject.clickHere")}
        </a>
        .
      </Typography>
    </Box>
  )
}

ModesTab.propTypes = {
  localProject: PropTypes.object.isRequired,
  setLocalProject: PropTypes.func.isRequired,
}
